import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/ProductSimilar/ProductSimilar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/ProductSlide/ProductSlide.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/iyde-build/public_html/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/productDet.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/rating.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/images/image.png");
